module.exports = __webpack_public_path__ + "img/heartIcon.e16a7fde.svg";